// DREAMINK CORE CONTROLLER
// Controls global experience flow without breaking existing logic

document.addEventListener('DOMContentLoaded', () => {
  DreamInk.init();
});

const DreamInk = {
  init() {
    this.setBodyState();
    this.initScrollSystem();
    this.initRevealSystem();
    this.initPageTransitions();
  },

  setBodyState() {
    document.body.classList.add('dreamink-loaded');
  },

  initScrollSystem() {
    let lastScroll = 0;

    window.addEventListener('scroll', () => {
      const current = window.scrollY;

      if (current > lastScroll) {
        document.body.classList.add('scroll-down');
        document.body.classList.remove('scroll-up');
      } else {
        document.body.classList.add('scroll-up');
        document.body.classList.remove('scroll-down');
      }

      lastScroll = current;
    });
  },

  initRevealSystem() {
    const elements = document.querySelectorAll('[data-animate]');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
        }
      });
    }, { threshold: 0.15 });

    elements.forEach(el => observer.observe(el));
  },

  initPageTransitions() {
    document.body.classList.add('page-ready');
  }
};